// extracted by css-extract-rspack-plugin
var _1 = "fheln6eFaaUngjwS";
var _2 = "teAPN8kMiwuim0X6";
export { _1 as "shadowItem", _2 as "shadowLayer" }
// extracted by css-extract-rspack-plugin
var _1 = "fheln6eFaaUngjwS";
var _2 = "teAPN8kMiwuim0X6";
export { _1 as "shadowItem", _2 as "shadowLayer" }
